<template>
  <div class="article-wrapper">
    <a-row type="flex" justify="space-between">
      <a-col :span="6">
        <a-menu
          mode="inline"
          :defaultSelectedKeys="['1']"
          :style="{ width: '250px', height: '80vh', borderRight: 0 , overflowY: 'auto', overflowX: 'hidden'}"
          @openChange="onOpenChange"
        >
          <a-menu-item
            v-for="article in articleList"
            :key="article.id"
            @click="currentArticle = article"
          >
            {{ article.title }}
          </a-menu-item>
        </a-menu>
      </a-col>
      <a-col :span="17">
        <div
          class="article-content"
          v-if="currentArticle"
          v-html="currentArticle.content"
        ></div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Vue from "vue";
import store from "@/store";
import { getArticleList, getArticleDetail } from "@/api/article";
export default {
  name: "ArticleList",
  data() {
    return {
      category: "",
      articleList: [],
      currentArticle: {},
    };
  },
  created() {
    this.category = this.$route.query.category;
    this.getArticleList(this.category);
  },
  mounted() {},
  methods: {
    getArticleList(category) {
      getArticleList(category, 1, 999).then((res) => {
        if (res.success) {
          this.articleList = res.result.records;
          if (res.result.total > 0) {
            this.currentArticle = this.articleList[0];
          } else {
            this.currentArticle.content = "暂无文章";
          }
        }
      });
    },

    selectArticle(article) {},

    onOpenChange(openKeys) {
      const rootSubmenuKeys = this.courseUnits.map((item) => {
        return item.id;
      });
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    launchIntoFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    exitFullscreen() {
      if (window.document.exitFullscreen) {
        window.document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        window.document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        window.document.webkitExitFullscreen();
      }
    },
  },
};
</script>

<style lang="less" scoped>

.article-wrapper {
  width: 1000px;
  min-height: 80vh;
  margin: 20px auto;
}
.article-content {
  padding: 20px;
  background: #fff;
  img {
    max-width: 100%;
  }
}
</style>